import clsx from 'clsx';
import { find, get } from 'lodash';
import {
  Contact,
  FileText,
  Menu,
  MessageSquare,
  MessagesSquare,
  Settings,
  Users,
  UsersRound,
} from 'lucide-react';
import { useSelector } from 'react-redux';
import { NavLink } from 'react-router-dom';
import { getRoutes } from '../../constants/Routes';
import useAuth from '../../hooks/useAuth';
import { Divider, Tooltip } from 'antd';

const Aside = ({ onClose, onSiderBarToggle, isLabeled = true }) => {
  const {
    user: { role },
  } = useAuth();
  const { chatContacts } = useSelector((state) => state.contactsSlice);

  const navItems = [
    { icon: <MessageSquare />, label: 'Chats', id: 'chats', access: [0, 1, 2] },
    { icon: <MessagesSquare />, label: 'Groups', id: 'groups', access: [0, 1, 2] },
    { icon: <Contact />, label: 'Contacts', id: 'contacts', access: [0, 1, 2, 3] },
    { icon: <UsersRound />, label: 'Customers', id: 'customers', access: [0, 1, 2] },
    { icon: <Users />, label: 'Users', id: 'users', access: [0, 1] },
    { icon: <FileText />, label: 'Templates', id: 'templates', access: [0] },
    { icon: <Settings />, label: 'Settings', id: 'settings', access: [0, 1, 2] },
  ];

  const filteredNavItems = navItems.filter((item) => item.access.includes(role));

  const getUnreadCount = () => {
    const unreadChat = find(chatContacts, (contact) => contact.unread_count > 0);
    return get(unreadChat, 'unread_count', 0);
  };

  return (
    <aside className="Aside">
      <div className="Aside__Mid">
        <div className="Aside__Mid__Menu">
          {!isLabeled && (
            <>
              <div className="aside-menu">
                <Menu cursor="pointer" onClick={onSiderBarToggle} />
              </div>
              <Divider style={{ margin: '0 0 10px' }} />
            </>
          )}
          {filteredNavItems?.map((item) => (
            <Tooltip key={item.id} title={!isLabeled && item.label} placement="right">
              <NavLink
                key={item.id}
                to={getRoutes()[item.id]?.route()}
                className={clsx('aside-menu', { dot: item.id === 'chats' && getUnreadCount() })}
                onClick={onClose}
              >
                <span className={clsx('icon', { dot: item.id === 'chats' && getUnreadCount() })}>
                  {item.icon}
                </span>
                {isLabeled && <span className="name">{item.label}</span>}
              </NavLink>
            </Tooltip>
          ))}
        </div>
      </div>
    </aside>
  );
};

export default Aside;
